<template>
  <div
    class="form-input"
    v-bind="$attrs"
    :class="[{ 'form-input--full': full, 'form-input--disabled': disabled }, { 'form-input--error': error }]"
  >
    <slot />
    <span class="form-input__label">{{ label }}</span>
    <div v-if="error" class="form-input__error" v-text="error" />
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    full: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: [Boolean, String],
      default: false
    }
  }
}
</script>
